import { useContext, useEffect, useState } from 'react';
import { OrgAuthContext } from '../context/OrgAuthContext';
import { Navigate, Route, Routes } from 'react-router-dom';
import OrgLoginPage from '../pages/orgLoginPage/OrgLoginPage';
import OrgRegister from '../pages/orgRegister/OrgRegister';
import { toast } from 'react-toastify';
import Footer from '../webPageSections/footer/Footer';
import OrgActivityLeftMenu from '../components/Activity/orgActivityLeftMenu/OrgActivityLeftMenu';
import ActivityDashboard from '../components/Activity/activityDashboard/ActivityDashboard';
import OrgActivityPackList from '../components/Activity/orgActivityPackList/OrgActivityPackList';
import OrgActivityBillings from '../components/Activity/orgActivityBillings/OrgActivityBillings';
import OrgActivityBookings from '../components/Activity/orgActivityBookings/OrgActivityBookings';
import OrgActivityReviews from '../components/Activity/orgActivityReviews/OrgActivityReviews';
import OrgActivityInsights from '../components/Activity/orgActivityInsights/OrgActivityInsights';
import OrgActivityAnalytics from '../components/Activity/orgActivityAnalytics/OrgActivityAnalytics';
import OrgHeader from '../webPageSections/orgPageSection/orgHeader/OrgHeader';
import OrgActivityPackUpload from '../pages/organizer/orgActivityPackUpload/OrgActivityPackUpload';
import OrgActivityDetails from '../pages/organizer/orgActivityDetails/OrgActivityDetails';
import OrgAccount from '../pages/orgAccount/OrgAccount';
import AddBookingOthers from '../components/addBookingOthers/AddBookingOthers';
import OrgActDateDetails from '../components/Activity/orgActDateDetails/OrgActDateDetails';
import AddBookingAct from '../components/addBookingOthers/AddBookingAct';
import { OrgDatesProvider } from '../context/OrgDatesContest';

const orgClearItems = ['orgName', 'orgId', 'orgToken', 'orgExpiry', 'type', 'org'];
const headerButtons = {
    roleText: ['Add Booking', 'Create Activity'],
    rolelink: ['/org/a/create/pack', '/org/a/create/pack']
};

export default function OrgActivityLayout() {
    const { isOrgAuthenticated } = useContext(OrgAuthContext);
    const [addBo, setAddBo] = useState(false);
    const isLoginExpiredOrg = () => {
        const expiryTime = Number(window.localStorage.getItem('orgExpiry'));
        return expiryTime && Date.now() > expiryTime;
    };

    const monitorLoginExpiryOrg = () => {
        const interval = setInterval(() => {
            if (window.location.pathname !== '/org/login') {
                if (isLoginExpiredOrg()) {
                    toast.error('Session has expired. Login again to continue');
                    setTimeout(() => {
                        orgClearItems.forEach((key) => {
                            localStorage.removeItem(key); // Removes the specified key
                        }); // Clear all local storage
                        clearInterval(interval); // Stop further checks
                        window.location = '/org/login';
                    }, 3000);
                }
            }
        }, 10000); // Check every 10 seconds
    };

    useEffect(() => {
        //The below if consition shouln't be used as it will make the duntion
        //not get triggred in other pages also
        monitorLoginExpiryOrg();
        //eslint-disable-next-line
    }, []);

    return (
        <>
            {isOrgAuthenticated ? (
                <>
                    <OrgHeader
                        roleText={headerButtons.roleText}
                        rolelink={headerButtons.rolelink}
                        setAddBo={setAddBo}
                    />
                    <div className='org-main-container'>
                        <OrgActivityLeftMenu />
                        <main className='org-content'>
                            <Routes>
                                <Route path='/register' element={<OrgRegister />} />
                                <Route path='/*' element={<Navigate to='dashboard' />} />
                                <Route path='/dashboard' element={<ActivityDashboard />} />
                                <Route path='/my-activity' element={<OrgActivityPackList />} />
                                <Route path='/billing' element={<OrgActivityBillings />} />
                                <Route path='/payouts' element={<OrgActivityBillings />} />
                                <Route path='/bookings' element={<OrgActivityBookings />} />
                                <Route path='/reviews' element={<OrgActivityReviews />} />
                                <Route path='/account' element={<OrgAccount />} />
                                <Route path='/create/pack' element={<OrgActivityPackUpload />} />
                                <Route path='/date/:actDateId/:slotId' element={<OrgActDateDetails />} />
                                <Route
                                    path='/activity/details/:activityId'
                                    element={
                                        <OrgDatesProvider>
                                            <OrgActivityDetails />
                                        </OrgDatesProvider>
                                    }
                                />
                                <Route path='/insights' element={<OrgActivityInsights />} />
                                <Route path='/analytics' element={<OrgActivityAnalytics />} />
                            </Routes>
                        </main>
                        <Footer />
                    </div>
                    {addBo && <AddBookingAct setAddBo={setAddBo} />}
                </>
            ) : (
                <Routes>
                    <Route path='/login' element={<OrgLoginPage />} />
                    <Route path='/*' element={<Navigate to='login' />} />
                    <Route path='/register' element={<OrgRegister />} />
                </Routes>
            )}
        </>
    );
}
